import {ElementSelectionService, LinkService, SelectionService} from '@frontapp/editor-html';

import {sanitizeHrefInput} from '../../libs/shared/core/src/helpers/browser/urlHelpers';

/*
 * Helpers.
 */

/** If text resembling a URL is selected and it's not already linked, turn it into a link. */
export function trySetLinkUrlFromSelectedText(linkService: LinkService): boolean {
  const {url, selectedText} = linkService;

  // Check whether the selection already has a link.
  if (url) {
    return false;
  }

  // Check if the selected text is a valid URL.
  const selectedUrl = sanitizeHrefInput(selectedText);
  if (!selectedUrl) {
    return false;
  }

  linkService.setUrl(selectedUrl);
  return true;
}

export function isElementSelectionService(service: SelectionService): service is ElementSelectionService {
  return 'selection' in service;
}
